import './Heading.css';

function Heading({ level = 2, children, className = '' }) {
  const Tag = `h${level}`;
  const classNames = `heading heading--h${level} ${className}`.trim();
  return <Tag className={classNames}>{children}</Tag>;
}

export default Heading;
